import { render, staticRenderFns } from "./BlockEventDialog.vue?vue&type=template&id=072a1de2&scoped=true"
import script from "./BlockEventDialog.vue?vue&type=script&lang=js"
export * from "./BlockEventDialog.vue?vue&type=script&lang=js"
import style0 from "./BlockEventDialog.vue?vue&type=style&index=0&id=072a1de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a1de2",
  null
  
)

export default component.exports